// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { CREDIT_SUCCESSFUL_STATE } from 'consts/enrollmentCompletionStates';

export default {
  4: state => {
    const newState = produce(state, draft => {
      draft.enrollment = draft.enrollment || {};

      if (state.enrolledInCredit) {
        draft.enrollment.creditStatus = CREDIT_SUCCESSFUL_STATE;
        delete draft.enrolledInCredit;
      }
    });

    return newState;
  },
};
